
export default processData;
const complianceConfig: any = {
  "noise": {
    "Day": {
      "Quiet": 75,
      "Sensitive": 75,
      "Mixed": 75,
      "Category A": 50,
      "Category B": 55,
      "Category C": 60,
      "Category D": 65,
      "Roadsides": 70
    },
    "Evening": {
      "Quiet": 65,
      "Sensitive": 65,
      "Mixed": 65
    },
    "Night": {
      "Quiet": 45,
      "Sensitive": 45,
      "Mixed": 45,
      "Category A": 40,
      "Category B": 45,
      "Category C": 50,
      "Category D": 55,
      "Roadsides": 65
    }
  },
  "pm10": 340,
  "pm2p5": 35,
  "vibration": 2.5,
}
const OPEN_STATUSES = ["open", "reopen", "re-open", "re open"];
const normMonth = (m?: number | string) => {
  if (m == null) return "";
  const n = typeof m === "string" ? parseInt(m, 10) : m;
  return isFinite(n as number) ? String(n).padStart(2, "0") : String(m).trim().toLowerCase();
};
const monthYearKey = (month?: number | string, year?: number | string) =>
  `${normMonth(month)}-${year ?? ""}`;

const editableSet = (packageStatusResponse:any) => {
  const editableSet = new Set<string>();
  if (Array.isArray(packageStatusResponse)) {
    for (const s of packageStatusResponse) {
      const status = (s.Status ?? "").toString().trim().toLowerCase();
      if (OPEN_STATUSES.includes(status)) {
        const key = monthYearKey(s.Month, s.Year);
        if (key !== "-") editableSet.add(key);
      }
    }
  }
  return editableSet
}
const norm = (v: any) => String(v ?? "").trim().toLowerCase();
const isOpenStatus = (s: any) => /^(open|re-?open)$/i.test(String(s ?? "").trim());

// const canEdit = (item: any, packageStatusResponse: any[] = []) =>
//   !!item?.Month && !!item?.Year &&
//   packageStatusResponse.some(r =>
//     norm(r?.Month) === norm(item.Month) &&
//     norm(r?.Year)  === norm(item.Year)  &&
//     isOpenStatus(r?.Status)
//   );
const canEdit = (item: any, packageStatusResponse: any[] = []) => {
  if (!item?.Month || !item?.Year) return false;

  const matches = packageStatusResponse.filter(
    r => norm(r?.Month) === norm(item.Month) && norm(r?.Year) === norm(item.Year)
  );

  if (matches.length === 0) return true;                  // missing = allowed
  return matches.some(r => isOpenStatus(r?.Status));      // open-ish = allowed
};

function processData(logTitle: string, data: any, _ComplianceConfig?: any, packageStatusResponse:any = undefined) {
  const validConfig = _ComplianceConfig && !_ComplianceConfig.message ? _ComplianceConfig : {};
  const safeConfig = { ...complianceConfig, ...validConfig };
  
  switch (logTitle) {
    case 'Noise Monitoring Log':
      return (
        processData_Noise(data, safeConfig, packageStatusResponse)
      )
    case 'Energy Log':
      return (
        processData_Energy(data, packageStatusResponse)
      )
    case 'Water Log':
      return (
        processData_Water(data, packageStatusResponse)
      )
    case 'Imported Soil Log':
      return (
        processData_Soil(data, packageStatusResponse)
      )
    case 'Hazardous Material Storage Log':
      return (
        processData_HazMaterial(data, packageStatusResponse)
      )
    case 'Recycled Materials Log':
      return (
        processData_RecycledMaterials(data)
      )
    case 'Regional Materials Log':
      return (
        processData_RegionalMaterials(data)
      )
    case 'Vibration Monitoring Log':
      return (
        processData_Vibration(data, safeConfig, packageStatusResponse)
      )
    case 'PM10 Monitoring Log':
      return (
        processData_PM10(data, safeConfig, packageStatusResponse)
      )
    case 'PM2.5 Monitoring Log':
      return (
        processData_PM2P5(data, safeConfig, packageStatusResponse)
      )
    case 'Wastewater Tracking Log':
      return (
        processData_WasteWater(data, packageStatusResponse)
      )
    case 'Waste Tracking Log':
      return (
        processData_Waste(data, packageStatusResponse)
      )
    case 'Spoil Tracking Log':
      return (
        processData_Spoil(data, packageStatusResponse)
      )
    case 'Training Log':
      return (
        processData_Training(data, packageStatusResponse)
      )
    case 'Environmental Issues Observations':
      return (
        processData_Observations(data, packageStatusResponse)
      )
    case 'Permit Register':
      return (
        processData_PermitRegister(data)
      )
    case 'Permit And Licenses':
      return (
        processData_PermitRegister(data)
      )
    case 'Contracts':
      return (
        processData_PermitRegister(data)
      )
      case 'Package Status':
      return (
        processData_PermitRegister(data)
      )
    case 'Monthly Waste Log':
      return (
        processData_Waste(data, packageStatusResponse)
      )
    case 'Report Request':
      return (
        processData_ReportRequest(data)
      )
    case 'Project Records':
      return (
        processData_ProjectRecords(data)
      )
    default: return data
  }
}
function processData_Energy(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_Water(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_Soil(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_HazMaterial(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_RecycledMaterials(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    const Period = item.Date && GetPeriod(item.Date);
    const Date = item.Date && returnDate(item.Date);
    const TotalValueOfRecycleContentMaterial = (item.MaterialValue * item.RecycledContentPostConsumer) + (item.MaterialValue * item.RecycledContentPreConsumer * 0.5);
    return { ...item, key, Period, Date, TotalValueOfRecycleContentMaterial };
  });
  return updatedData;
}
function processData_RegionalMaterials(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    const Period = item.Date && GetPeriod(item.Date);
    const Date = item.Date && returnDate(item.Date);
    return { ...item, key, Period, Date };
  });
  return updatedData;
}
function processData_Vibration(data: any, _ComplianceConfig: any, packageStatusResponse:any) {

  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    let conformity = "";
    if (item.MonitoringResultsMaxPPVmms != "") {
      conformity = item.MonitoringResultsMaxPPVmms <= _ComplianceConfig.vibration ? "Conformity" : "Non Conformity";
    }

    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const ComplianceLimitmms = _ComplianceConfig.vibration;
    return { ...item, Conformity, Period, key, Date, pieKey, ComplianceLimitmms, Editable };
  });
  return updatedData;
}
function processData_PM10(data: any, _ComplianceConfig: any, packageStatusResponse:any) {

  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    let conformity = "";
    if (item.MonitoringResultsugm3 != "") {
      //conformity = item.MonitoringResultsugm3 <= item.ComplianceStandardugm3 ? "Conformity" : "Non Conformity";
      conformity = item.MonitoringResultsugm3 <= _ComplianceConfig.pm10 ? "Conformity" : "Non Conformity";
    }

    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const ComplianceStandardugm3 = _ComplianceConfig.pm10;
    return { ...item, Conformity, Period, key, Date, pieKey, ComplianceStandardugm3, Editable };
  });
  return updatedData;
}
function processData_PM2P5(data: any, _ComplianceConfig: any, packageStatusResponse:any) {

  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    let conformity = "";
    if (item.MonitoringResultsugm3 != "") {
      //conformity = item.MonitoringResultsugm3 <= item.ComplianceStandardugm3 ? "Conformity" : "Non Conformity";
      conformity = item.MonitoringResultsugm3 <= _ComplianceConfig.pm2p5 ? "Conformity" : "Non Conformity";
    }
    const Conformity = conformity
    const pieKey = Conformity;
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const ComplianceStandardugm3 = _ComplianceConfig.pm2p5;
    return { ...item, Conformity, Period, key, Date, pieKey, ComplianceStandardugm3, Editable };
  });
  return updatedData;
}
function processData_WasteWater(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_Waste(data: any, packageStatusResponse:any = undefined) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;    
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const Hazardous: string = checkHazardous(item.WasteType);
    const Diverted: string = checkDiverted(item.WasteDisposalMethod);
    //const canEdit = packageStatusResponse && editableSet(packageStatusResponse).has(monthYearKey(Month, Year));
    return { ...item, Period, key, Date, Hazardous, Diverted, Editable };
  });
  return updatedData;
}
function processData_Spoil(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const Reused: string = checkReused(item.SpoilDisposalMethod);
    return { ...item, Period, key, Date, Reused, Editable };
  });
  return updatedData;
}
function processData_Training(data: any, packageStatusResponse:any) {
  const updatedData = data.map((item: any) => {
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date, Editable };
  });
  return updatedData;
}
function processData_Observations(data: any, packageStatusResponse:any = undefined) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const Editable = "Yes";//canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    const DueDate = item.DueDate && item.DueDate != null ? returnDate(item.DueDate) : null;
    const DateClosedOut = item.DateClosedOut && item.DateClosedOut != null ? returnDate(item.DateClosedOut) : null;
    const Status = checkStatus(item.ClosedOut)
    const ReferenceNumber = item.ReferenceNumber === null ? item.ID : item.ReferenceNumber + "-" + item.ID;
    return { ...item, Period, key, Date, Status, ReferenceNumber, DueDate, DateClosedOut, Editable};
  });
  return updatedData;
}
function processData_PermitRegister(data: any) {
  const updatedData = data.map((item: any) => {
    const key = item.ID;
    const Editable = "Yes";
    //const PermitValidity = item.PermitValidity && returnDate(item.PermitValidity);
    const formattedItem = Object.keys(item).reduce((acc, field) => {
      const value = item[field];

      // Check if field name contains "date" (case-insensitive)
      const isDateField = /date/i.test(field);

      // If it's a date-like field and value is a valid date, format it
      if (isDateField && value && !isNaN(Date.parse(value))) {
        acc[field] = returnDate(value);
      } else {
        acc[field] = value;
      }

      return acc;
    }, {} as any);
    return { ...formattedItem, key, Editable };
  });
  return updatedData;
}
function processData_ReportRequest(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const Date = item.Date && returnDate(item.Date);
    const key = item.ID;
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_ProjectRecords(data: any) {
  const updatedData = data.map((item: any) => {
    const Period = item.Date && GetPeriod(item.Date);//item.Month + '-' + item.Year;
    const key = item.ID;
    const Date = item.Date && returnDate(item.Date);
    return { ...item, Period, key, Date };
  });
  return updatedData;
}
function processData_Noise(data: any, _ComplianceConfig: any, packageStatusResponse:any) {

  const updatedData = data.map((item: any) => {
    const v1 = parseFloat(item.MonitoringResults1LAeqdBA);
    const v2 = parseFloat(item.MonitoringResults2LAeqdBA);
    const v3 = parseFloat(item.MonitoringResults3LAeqdBA);

    const MaxLAeq = Math.max(v1, v2, v3);
    const AverageLAeq = ((v1 + v2 + v3) / 3).toFixed(2);

    let NoiseLevel: number | null = null;
    if (item.Hour24H !== '') {
      const { TimePeriod, LocationType } = item;
      NoiseLevel = _ComplianceConfig.noise[TimePeriod]?.[LocationType] ?? 70;
    }
    const Editable = canEdit(item, packageStatusResponse) ? "Yes" : "No";
    const Conformity = MaxLAeq <= (NoiseLevel ?? 80) ? 'Conformity' : 'Non Conformity';
    const Period = item.Date ? GetPeriod(item.Date) : '';
    const Date = item.Date ? returnDate(item.Date) : '';
    const pieKey = Conformity;
    const key = item.ID;

    return {
      ...item,
      MaxLAeq,
      AverageLAeq,
      NoiseLevel,
      Conformity,
      Period,
      Date,
      pieKey,
      key,
      Editable
    };
  });

  return updatedData;
}
function returnDate(value: Date) {
  if (value) {
    const date = new Date(value);
    const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
    const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
    const day = adjustedDate.getDate();
    const month = adjustedDate.getMonth() + 1;
    const year = adjustedDate.getFullYear();
    const formattedDate = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
    return formattedDate;
  } else {
    return value;
  }

}
function GetPeriod(value: Date) {
  if (value && value != null) {
    const date = new Date(value);
    const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
    const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
    const day = adjustedDate.getDate();
    const month = adjustedDate.getMonth() + 1;
    const year = adjustedDate.getFullYear();
    const formattedDate = `${month < 10 ? '0' + month : month}-${year}`;
    return formattedDate;
  } else {
    return value;
  }
}
function checkDiverted(div: string) {
  if (!div) return null;
  const d = div.trim().toLowerCase();
  if (/reuse|re-use|recycl|recover|compost|energy\s*recover/i.test(d)) return "Diverted";
  if (/landfill|dump\s*site|incinerat|other/i.test(d)) return "Not Diverted";
  return null;
}

function checkHazardous(wT: string) {
  //let val;
  switch (wT) {
    case "Paper/ Cardboard": return "Non Hazardous";
    case "Plastic": return "Non Hazardous";
    case "Metal": return "Non Hazardous";
    case "Wood": return "Non Hazardous";
    case "Green": return "Non Hazardous";
    case "Concrete/ Inert debris": return "Non Hazardous";
    case "Asphalt": return "Non Hazardous";
    case "General Domestic/ Food waste": return "Non Hazardous";
    case "General Construction/ Mixed Waste": return "Non Hazardous";
    case "Electronic (without hazardous materials)": return "Non Hazardous";
    case "Other (non hazardous)": return "Non Hazardous";

    case "Electronic (containing hazardous materials)": return "Hazardous";
    case "Used oil": return "Hazardous";
    case "Used oil filters": return "Hazardous";
    case "Contaminated material (including contaminated pads, rags, gloves and soil)": return "Hazardous";
    case "Batteries": return "Hazardous";
    case "Medical": return "Hazardous";
    case "Other (hazardous)": return "Hazardous";
    default: return null
  }
}
function checkReused(div: string) {
  switch (div) {
    case "Reuse on-site": return "Reuse";
    case "Reuse off-site": return "Reuse";
    case "Temporary storage for future reuse": return "Reuse";

    case "Disposal off-site": return "Not Reused";
    case "Landfill": return "Not Reused";
    case "Slurry lagoon": return "Not Reused";
    case "Other": return "Not Reused";
    default: return null
  }
}
function checkStatus(div: string) {
  switch (div) {
    case "Yes": return "Closed";
    case "No": return "Open";
    case "Escalated": return "Escalated";
    default: return null
  }
}
const deriveMonthYearFromDate = (d?: string | Date | null) => {
  if (!d) return { Month: undefined, Year: undefined };
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return { Month: undefined, Year: undefined };
  return { Month: dt.getMonth() + 1, Year: dt.getFullYear() };
};